
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { DateHelper } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IMember, ITeamWebsite } from "../../../../../services";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { DASHBOARD_URL, pagePath, teamInitials, teamLogo, visiblePages } from "../../helpers";

export interface FooterProps {
    basePath: string;
    profile?: IMember;
    website: ITeamWebsite;
}

function Footer({ website, basePath, profile }: FooterProps) {

    const mainLabels = globalI18nManager.Labels;
    const year = DateHelper.getStartOfDay().getFullYear();
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const owner = website.owns_copyright ? website.team.name : mainLabels.omnehost;
    const socials = Object.entries(website.owns_copyright ? (website.social_accounts ?? {}) : { ...Utils.OMNEHOST_SOCIALS, ...(website.social_accounts ?? {}) });
    const logo = teamLogo(website);

    return (<footer className={styles["footer"]}>
        <div className={styles["container"]}>
            <div className={styles["footer-grid"]}>
                <div className={styles["footer-brand"]}>
                    {logo ? (<img className={styles["footer-logo"]} src={logo} alt={website.team.name} />) : (<span className={styles["nav-logo-text"]}>{teamInitials(website.team.name)}</span>)}
                    <div className={styles["footer-socials"]}>
                        {socials.map(([social, username]) => (
                            <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username as string)} aria-label={social} className={styles["social-btn"]}>
                                <i className={Utils.getSocialIcon(social) ?? "fa fa-link"} />
                            </ReactRouterDom.NavLink>
                        ))}
                    </div>
                </div>
                <div>
                    <p className={styles["footer-title"]}>{website.team.name}</p>
                    <nav className={styles["footer-links"]}>
                        {visiblePages(website).map(([page, pageSettings]) => (
                            <ReactRouterDom.NavLink key={page} end to={{ pathname: pagePath(basePath, page), search: searchParams.toString() }}>{pageSettings.label}</ReactRouterDom.NavLink>
                        ))}
                    </nav>
                </div>
                {!website.owns_copyright ? (<div>
                    <p className={styles["footer-title"]}>{mainLabels.omnehost}</p>
                    <nav className={styles["footer-links"]}>
                        <a target="_blank" rel="noreferrer" href={DASHBOARD_URL}>{profile ? mainLabels.auth.dashboard : mainLabels.auth.sign_in}</a>
                        {mainLabels.footer.map((f) => (<a key={f.label} target="_blank" rel="noreferrer" href={f.location}>{f.label}</a>))}
                    </nav>
                </div>) : (<div>
                    <p className={styles["footer-title"]}>{website.team.name}</p>
                    <p className={styles["footer-text"]}>{website.team.description || i18nManager.Labels.footer.established.replace(":name", website.team.name)}</p>
                </div>)}
            </div>
            <div className={styles["footer-bottom"]}>
                <span>© {year} {owner}. {mainLabels.landing.all_r_reserved}</span>
                {!website.owns_copyright && (<span>{mainLabels.omnehost_detail}</span>)}
            </div>
        </div>
    </footer>);
}

export default Footer;
